import { setAnalyzePoints } from './_event';
import {
  updateWorkName,
  emitUpload,
  updateProfessionName,
  updateParam,
} from './_upload';
import { rewriteDefineproperty } from './_observer';
import { emitEnter, emitActive } from './_enter';
import conf from './_conf';
import { isIE } from '../../utiles/device';
import { emitRouter } from './_router';

export const routerEnter = emitRouter;
export const updateDefaultParam = updateParam;
export const commonEmitUpload = emitUpload;
/**
 * professionName:业务标识
 * workName:入口名
 * keepAlive：是否设置了keepAlive
 */
export default (professionName, workName, keepAlive) => {
  // 更新业务标识
  updateProfessionName(professionName);
  // 更新配置归属
  updateWorkName(workName);

  // 如果需要监听属性
  if (conf[workName] && conf[workName].observer) {
    rewriteDefineproperty();
  }

  // 退出页面统一事件
  window.onbeforeunload = function () {
    emitUpload('leave-page');
    if (isIE()) {
      return;
    }
    return null;
  };

  return {
    install(Vue) {
      // 如果需要绑定dom事件
      if (conf[workName] && conf[workName].event) {
        let _oldRender = Vue.prototype._render;
        Vue.prototype._render = function () {
          let args = Array.prototype.slice.call(arguments);
          let vnode = _oldRender.apply(this, args);
          try {
            setAnalyzePoints(vnode);
          } catch (error) {
            console.error(error);
          }
          return vnode;
        };
      }
      // 如果需要监听组件生成
      if (conf[workName] && conf[workName].enter) {
        if (Vue.options.beforeCreate instanceof Array) {
          Vue.options.beforeCreate.unshift(function () {
            emitEnter(this.$options.name);
          });
        } else {
          Vue.options.beforeCreate = [
            function () {
              emitEnter(this.$options.name);
            },
          ];
        }
        if (keepAlive) {
          Vue.prototype.$pointEmitActive = emitActive;
          Vue.mixin({
            activated() {
              this.$pointEmitActive(this.$options.name);
            },
          });
        }
      }
    },
  };
};
